module.exports = __webpack_public_path__ + "media/images/entry/entry_btn3_ov-12bc5ed6e6a8c752d9cd870052d2f31a.gif";